export const passwordCardHeader = {
	main: {
		title: "Tarjeta de contraseñas",
		description:
			"Las tarjetas de contraseñas se utilizan en sustitución de las contraseñas digitadas y funcionan por aproximación, agilizando así la operación. De esta forma, solo aquellos que posean estas tarjetas estarán aptos para autorizar ciertas acciones en el PDV, ofreciendo mayor control y seguridad para procedimientos relevantes como retiro de efectivo y reembolso.",
		labelText: "Buscar",
		placeholder: "Busque por el dueño de la tarjeta",
		statusFilter: "Mostrar solo tarjetas activas",
	},
	stockHistory: {
		title: "Tarjeta de contraseñas - Historial de acciones",
		cardOwner: "Dueño(a) de la tarjeta: ",
	},
	blockButton: "Bloquear múltiples tarjetas",
};
